// @ts-check
import { useAppConfigStore } from '@/js/stores/appConfig';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

export const useUserUuid = () => {
  const { userEnviroment } = storeToRefs(useAppConfigStore());

  const userUuid = computed(/** @returns {string | undefined} */ () => {
    if (!userEnviroment.value) {
      return undefined;
    }

    const installationCode = userEnviroment.value.Instalacion?.Codigo;
    if (!installationCode) {
      return undefined;
    }

    const userId = userEnviroment.value.EntornoDeTrabajo.Usuario?.Id;
    if (!userId) {
      return undefined;
    }

    return `${installationCode}-${userId}`;
  });

  return {
    userUuid,
  };
};
